<template>
  <button
    class="focus:outline-none text-center"
    :class="[style, sizeStyle]"
    @click.prevent="emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  PRIMARY: 'primary',
  DANGER: 'danger',
  props: {
    type: {
      type: String,
      default: 'default',
      // choices: "primary", "danger", "default"
    },
    size: {
      type: String,
      default: 'base',
      // choices: "xs", "sm", "base", "lg", "xl"
    },
    underlined: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const baseStyle = computed(() => {
      const styles = []
      if (props.underlined) {
        styles.push('underline')
      }
      return styles.join(' ')
    })
    const style = computed(() => {
      return (
        baseStyle.value +
        ' ' +
        {
          default: 'text-true-gray-600 hover:text-yellow-600',
          primary: 'text-yellow-500 hover:text-yellow-600',
          danger: 'text-red-500 hover:text-red-600',
        }[props.type]
      )
    })

    const sizeStyle = computed(() => {
      return {
        sm: 'text-xs',
        base: 'text-sm',
        lg: 'text-base',
      }[props.size]
    })

    return {
      style,
      sizeStyle,
      emit,
    }
  },
}
</script>
